// Non-component exports for the demo i18n system.
// Kept separate from i18n.tsx so React Fast Refresh can hot-reload
// components without bouncing the context each time.
import { createContext, useContext } from 'react'

export type Lang = 'en' | 'mk' | 'gr'

export const LANG_LABELS: Record<Lang, { flag: string; name: string }> = {
  en: { flag: '🇬🇧', name: 'English' },
  mk: { flag: '🇲🇰', name: 'Македонски' },
  gr: { flag: '🇬🇷', name: 'Ελληνικά' },
}

export type Dict = Record<string, Record<Lang, string>>

export type I18nCtx = { lang: Lang; setLang: (l: Lang) => void; t: (key: string) => string }

export const I18nContext = createContext<I18nCtx | null>(null)

export function useT() {
  const ctx = useContext(I18nContext)
  if (!ctx) throw new Error('useT() must be used inside <I18nProvider>')
  return ctx
}
